"use client"

import styled from "@emotion/styled"
import { useTranslations } from "next-intl"
import { useEffect } from "react"
import { X3Icon } from "../icons"
import ContactCard from "./ContactCard"

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1300;
`

const StyledDrawer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  z-index: 1301;
  overflow: hidden;
`

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  flex-shrink: 0;
`

const StyledTitle = styled.span`
  flex: 1;
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 0.6px;
  color: #0e2846;
  text-transform: capitalize;
`

const StyledCloseButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  svg {
    width: 14px;
    height: 14px;
  }
`

const StyledScroll = styled.div`
  flex: 1;
  overflow-y: auto;
`

type ContactDrawerProps = {
  open: boolean
  onClose: () => void
  data?: any
  companyId?: number
  showPrice?: boolean
  showDatePicker?: boolean
  price?: string
  companySectionLabel?: string
}

export default function ContactDrawer({
  open,
  onClose,
  data,
  companyId,
  showPrice,
  showDatePicker,
  price,
  companySectionLabel,
}: ContactDrawerProps) {
  const t = useTranslations("portMeetingRoomProduct")

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
    return () => {
      document.body.style.overflow = ""
    }
  }, [open])

  if (!open) return null

  return (
    <>
      <StyledOverlay onClick={onClose} />
      <StyledDrawer>
        <StyledHeader>
          <StyledTitle>{t("scheduleTour")}</StyledTitle>
          <StyledCloseButton onClick={onClose}>
            <X3Icon color="#0e2846" />
          </StyledCloseButton>
        </StyledHeader>
        <StyledScroll>
          <ContactCard
            data={data}
            companyId={companyId}
            variant="inline"
            showPrice={showPrice}
            showDatePicker={showDatePicker}
            price={price}
            companySectionLabel={companySectionLabel}
          />
        </StyledScroll>
      </StyledDrawer>
    </>
  )
}
